import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/filters/unpaid-installment/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const unpaidInstallment = {
  get: apiPathFunc(pathBase),
} as const;
